/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Archive_MissingInputs */

const cs_ebr_archive_missing = /** @type {(inputs: Ebr_Archive_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivovat nabídky, které ve feedu chybí`)
};

const en_ebr_archive_missing = /** @type {(inputs: Ebr_Archive_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archive offers missing from the feed`)
};

/**
* | output |
* | --- |
* | "Archive offers missing from the feed" |
*
* @param {Ebr_Archive_MissingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_archive_missing = /** @type {((inputs?: Ebr_Archive_MissingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Archive_MissingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_archive_missing(inputs)
	return cs_ebr_archive_missing(inputs)
});